export default __webpack_public_path__ + "static/media/placeholder_team.c23b4044.png";